// Project imports
import * as types from './actionTypes';

export const setAccountDetail = data => ({
  type: types.GET_ACCOUNTS,
  payload: data,
});

export const setActiveAccount = accountId => ({
  type: types.SET_ACTIVE_ACCOUNT,
  accountId,
});
export const setPerferedAccount = accountId => ({
  type: types.PREFERED_ACCOUNT_ID,
  preferedAccountId: accountId,
});
